import { put, call, takeEvery } from "redux-saga/effects";
import { getPagesAction, getPagesSuccess, getPagesFailure, getBlogsAction, getBlogsSuccess, getBlogsFailure } from "../slices/page";
import { fetchPages, fetchBlogs } from "../apis/page";

// Fetch all pages
function* getPages(): Generator {
    try {
        const products: any = yield call(fetchPages);
        console.log("Fetched Pages Response:", products); // Add this!

        yield put(getPagesSuccess(products));

    } catch (error: any) {
        yield put(getPagesFailure(error.message || "Failed to fetch products"));
    }
}


// Fetch all blogs
function* getBlogs(): Generator {
    try {
        const blogs: any = yield call(fetchBlogs);
        console.log("Fetched Blogs Response:", blogs); // Add this!

        yield put(getBlogsSuccess(blogs));

    } catch (error: any) {
        yield put(getBlogsFailure(error.message || "Failed to fetch blogs"));
    }
}


// Watcher Saga
export default function* pagesSaga() {
    yield takeEvery(getPagesAction.type, getPages);
    yield takeEvery(getBlogsAction.type, getBlogs);
}
